import LogoAskFreya from 'src/assets/images/ask-freya.svg';

const WelcomeScreen: React.FC = () => (
  <div className='flex-1 flex flex-col items-center justify-center p-8 overflow-y-auto relative overflow-hidden'>
    <div className='absolute w-[534px] h-[359px] rounded-full bg-[rgba(0,153,43,0.40)] blur-[232px] top-[-100%] 3xl:top-[-40%]' />
    <div className='relative mb-10 w-[60px] h-[60px]'>
      <img src={LogoAskFreya} alt='Ask Freya' />
    </div>

    <div className='text-center space-y-3'>
      <h2 className='text-26 2xl:text-28 leading-28 2xl:leading-30 font-medium tracking-tight'>Hi! I&apos;m FREYA.</h2>
      <h3 className='text-26 2xl:text-28 leading-28 2xl:leading-30 font-medium'>How can I help you today?</h3>
    </div>
  </div>
);

export default WelcomeScreen;
